import { UseQueryResult, useQuery } from "@tanstack/react-query";
import { axiosCentral, throwResponse } from "config/axios";
import { IDashboardParams, IResponseDashboardCentral } from "../../interface";
import { IVehicle, IVehicleBrand } from "./interface";

export const useGetDashboardVehicle = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IVehicle[]>[], Error> => {
  return useQuery(
    ["dashboard-vehicle", "most-used-vehicle-types", params],
    async () => {
      const res = await axiosCentral.get(
        "dashboard/vehicle/most-used-vehicle-types",
        { params }
      );
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};

export const useGetDashboardMostVehicle = (
  params?: IDashboardParams
): UseQueryResult<IResponseDashboardCentral<IVehicleBrand[]>[], Error> => {
  return useQuery(
    ["dashboard-vehicle", "graph-of-sticker", params],
    async () => {
      const res = await axiosCentral.get("dashboard/vehicle/graph-of-sticker", {
        params,
      });
      if (res.status === 200) {
        return res.data.data;
      }
      throwResponse(res);
    },
    { enabled: params?.enabled }
  );
};
